class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce(event => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector('form').addEventListener(
      'input',
      this.debouncedOnSubmit.bind(this)
    );
    // this.btnClearFilters = this.querySelector('facet-remove')?.querySelector('a');
    // MERGE: Desktop/Mobile Filter & Sort Redesign
    // The redesigned facets can render more than one Clear Filters control
    // (for example desktop and mobile), so keep all of them in sync.
    this.btnClearFilters = this.querySelectorAll('facet-remove a');
  }

  clearCheckboxes() {
    const checkboxes = this.querySelectorAll(
      'input[type="checkbox"]'
    );
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
  }

  static setListeners() {
    const onHistoryChange = event => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    sections.forEach(section => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (section.isBannerSection) {
        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderBannerFromCache(filterDataUrl)
          : FacetFiltersForm.renderBannerFromFetch(url);
      } else {
        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url }
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderCollectionView(html);
      });
  }

  static renderBannerFromFetch(url) {
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html: responseText, url }
        ];
        FacetFiltersForm.renderBannerCount(responseText);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderCollectionView(html);
  }

  static renderBannerFromCache(filterDataUrl) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderBannerCount(html);
  }

  static renderBannerCount(html) {
    const count = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('SearchHeroResultCount');
    const container = document.getElementById('SearchHeroResultCount');
    if (container && count) {
      container.innerHTML = count.innerHTML;
    }
  }

  static renderCollectionView(html) {
    const collectionView = document.querySelector('collection-view');
    const collectionViewParent = collectionView?.parentElement;

    if (!collectionView) {
      return;
    }

    const updatedCollectionView = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('collection-view');

    if (!updatedCollectionView) {
      return;
    }

    const updatedCollectionViewParent = updatedCollectionView.parentElement;
    const isHidden = updatedCollectionViewParent.classList.contains('hidden');

    isHidden ? collectionViewParent.classList.add('hidden') : collectionViewParent.classList.remove('hidden');
  }

  static renderProductGridContainer(html) {
    const productGridContainer = document.querySelector('#ProductGridContainer');
    const collectionView = document.querySelector('collection-view');

    const updatedProductGridContainer = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('#ProductGridContainer');

    if (collectionView) {
      const btnActive = collectionView.querySelector('.js-btn:disabled');
      const updatedProductGrid = updatedProductGridContainer.querySelector('#product-grid');

      updatedProductGrid ? updatedProductGrid.dataset.cols = btnActive.dataset.cols : '';
    }

    productGridContainer.innerHTML = updatedProductGridContainer.innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCount');
    const container = document.getElementById('ProductCount');

    if (container) {
      container.innerHTML = count ? count.innerHTML : '';
    }
  }

  // MERGE: Desktop/Mobile Filter & Sort Redesign
  // AJAX filtering and browser back/forward navigation can update sort_by
  // without replacing both responsive sort controls, so keep them synchronized.
  static renderSortControls(parsedHTML) {
    const sourceSortInput =
      parsedHTML.querySelector('[data-facet-sort="mobile"] select') ||
      parsedHTML.querySelector('[data-facet-sort] select');

    if (!sourceSortInput) return;

    document
      .querySelectorAll('#FacetFiltersForm [data-facet-sort] select')
      .forEach(sortInput => {
        FacetFiltersForm.setSortInputValue(
          sortInput,
          sourceSortInput.value
        );
      });
  }

  // MERGE: Desktop/Mobile Filter & Sort Redesign
  // Synchronizes both the native <select> used by Shopify FormData and
  // the custom-select UI shown to the customer.
  static setSortInputValue(sortInput, value) {
    const selectedOption = Array.from(sortInput.options).find(
      option => option.value === value
    );

    if (!selectedOption) return;

    sortInput.value = value;

    Array.from(sortInput.options).forEach(option => {
      const isSelected = option === selectedOption;

      option.selected = isSelected;
      option.toggleAttribute('selected', isSelected);
    });

    const customSelect = sortInput.closest('custom-select');
    const customSelectButton =
      customSelect?.querySelector('.js-btn-dropdown');
    const optionButtons =
      customSelect?.querySelectorAll('.js-btn-option');

    if (!customSelectButton || !optionButtons) return;

    customSelect.dataset.value = value;

    optionButtons.forEach(optionButton => {
      const isSelected = optionButton.dataset.value === value;

      optionButton.classList.toggle('is-selected', isSelected);
      optionButton.setAttribute('aria-selected', isSelected);
    });

    const selectedOptionLabel = customSelectButton.querySelector(
      '.custom-select__selected-option'
    );

    if (selectedOptionLabel) {
      selectedOptionLabel.textContent =
        selectedOption.textContent;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    // MERGE: Desktop/Mobile Filter & Sort Redesign
    // Shopify may return a different sort_by value after AJAX filtering or
    // browser history navigation. Keep both responsive controls on that value.
    FacetFiltersForm.renderSortControls(parsedHTML);

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter'
    );
    const matchesIndex = element => {
      const jsFilter = event
        ? event.target.closest('.js-filter')
        : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      element => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(
      matchesIndex
    );

    facetsToRender.forEach(element => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest('.js-filter')
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelector = '.js-facets-active';
    const activeFacetsElement = html.querySelector(
      activeFacetElementSelector
    );

    if (!activeFacetsElement) return;
    document.querySelector(activeFacetElementSelector).outerHTML =
      activeFacetsElement.outerHTML;
  }

  static renderCounts(source, target) {
    const selector = '.js-facets-selected';
    const targetElement = target.querySelector(selector);
    const sourceElement = source.querySelector(selector);

    if (sourceElement && targetElement) {
      target.querySelector(selector).outerHTML =
        source.querySelector(selector).outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)
      }`
    );
  }

  static getSections() {
    const sections = [
      {
        section: document.querySelector('facet-filters-form').dataset.sectionId
      }
    ];

    // On search pages, also include the banner section so its result count updates
    const bannerEl = document.querySelector('[data-search-banner-section]');
    if (bannerEl) {
      sections.push({
        section: bannerEl.dataset.searchBannerSection,
        isBannerSection: true
      });
    }

    return sections;
  }


  // MERGE: Desktop/Mobile Filter & Sort Redesign
  // Determine which responsive sort control should contribute sort_by.
  // If the user directly changed a sort select, that control takes priority.
  getActiveSortInput(event) {
    const eventTarget = event?.target;

    if (
      eventTarget?.matches?.('select[name="sort_by"]') &&
      this.contains(eventTarget)
    ) {
      return eventTarget;
    }

    const context = window.matchMedia('(max-width: 749px)').matches
      ? 'mobile'
      : 'desktop';

    return (
      this.querySelector(
        `[data-facet-sort="${context}"] select`
      ) ||
      this.querySelector('[data-facet-sort] select')
    );
  }

  // MERGE: Desktop/Mobile Filter & Sort Redesign
  // Both responsive sort controls represent the same Shopify sort_by value.
  // Synchronizing them prevents duplicate/conflicting sort parameters.
  syncSortInputs(sourceSortInput) {
    if (!sourceSortInput) return;

    this.querySelectorAll('[data-facet-sort] select').forEach(
      sortInput => {
        FacetFiltersForm.setSortInputValue(
          sortInput,
          sourceSortInput.value
        );
      }
    );
  }





  onSubmitHandler(event) {
    event.preventDefault();
    const context = event.target.id.includes('desktop')
      ? 'mobile'
      : 'desktop';


    // const formData = new FormData();
    // const closestForm = event.target.closest('form');
    // if (!closestForm) return;
    // const formDataElements = Array.from(
    //   closestForm.elements
    // ).filter(
    //   element =>
    //     !element.id.includes(context) || element.name === 'sort_by'
    // );


    const formData = new FormData();
    const closestForm = event.target.closest('form');

    if (!closestForm) return;

    // MERGE: Desktop/Mobile Filter & Sort Redesign
    // Only the active responsive sort field should be submitted.
    // Otherwise desktop + mobile can produce duplicate sort_by parameters.
    const activeSortInput = this.getActiveSortInput(event);

    this.syncSortInputs(activeSortInput);

    const formDataElements = Array.from(
      closestForm.elements
    ).filter(element => {
      if (element.name === 'sort_by') {
        return element === activeSortInput;
      }

      return !element.id.includes(context);
    });


    let sortByValue = null;

    for (const element of formDataElements) {
      if (!element.name) continue;
      if (element.type === 'checkbox') {
        if (element.checked) {
          formData.append(element.name, element.value);
        }
      } else {
 
        formData.append(element.name, element.value);

        if (element.name === 'sort_by') {
          sortByValue = element.value;
        }
      }
    }
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);

    // if (!sortByValue) {
    //   return;
    // }

    // const sortParam = 'sort_by=';
    // const sortValueIndex = this.btnClearFilters.href.indexOf(sortParam);
    // let updatedBtnURL = this.btnClearFilters.href.slice(0, sortValueIndex + sortParam.length) + sortByValue;

    // const currentSearch = new URLSearchParams(window.location.search);
    // if (currentSearch.has('q')) {
    //   const qValue = currentSearch.get('q');
    //   if (!updatedBtnURL.includes('q=')) {
    //     updatedBtnURL = updatedBtnURL.replace('?', `?q=${qValue}&`);
    //   }
    // }

    // this.btnClearFilters.href = updatedBtnURL;

    if (!sortByValue || !this.btnClearFilters.length) {
      return;
    }

    // MERGE: Desktop/Mobile Filter & Sort Redesign
    // Keep every Clear Filters link on the same sort_by value so clearing
    // filters does not unexpectedly reset sorting on either responsive UI.
    const sortParam = 'sort_by=';

    this.btnClearFilters.forEach(btnClearFilters => {
      const sortValueIndex =
        btnClearFilters.href.indexOf(sortParam);

      let updatedBtnURL =
        btnClearFilters.href.slice(
          0,
          sortValueIndex + sortParam.length
        ) + sortByValue;

      const currentSearch =
        new URLSearchParams(window.location.search);

      if (currentSearch.has('q')) {
        const qValue = currentSearch.get('q');

        if (!updatedBtnURL.includes('q=')) {
          updatedBtnURL =
            updatedBtnURL.replace('?', `?q=${qValue}&`);
        }
      }

      btnClearFilters.href = updatedBtnURL;
    });


  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf('?') + 1
        );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input');
  

    this.inputs.forEach(element =>
      element.addEventListener(
        'change',
        this.onRangeChange.bind(this)
      )
    );

    this.setMinAndMaxValues();
  }
 

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const minInput = this.inputs[0];
    const maxInput = this.inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', event => {
      event.preventDefault();
      const form =
        this.closest('facet-filters-form') ||
        document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
      form.clearCheckboxes();
    });
  }
}

customElements.define('facet-remove', FacetRemove);
